module.exports = __webpack_public_path__ + "static/media/stylcheck.78cfbb70.png";